





































































































































































































































































































import Vue from "vue";
import CheckBox from "@/components/basic/fields/CheckBox.vue";
import Field from "@/components/basic/fields/Field.vue";
import FieldMask from "@/components/basic/fields/FieldMask.vue";
import Select from "@/components/basic/fields/Select.vue";
import SubmitButton from "@/components/basic/buttons/SubmitButton.vue";
import { CorrespondenceMethod } from "@/constants/form-values";
import { AddressResponseInterface, DataObject, FieldInterface, StepResidenceDetails } from "@/types";
import { SET_PROGRESS } from "@/constants/mutation-types";
import { mapState } from "vuex";
import { Action } from "@/constants/ajax";
import AutocompleteField from "@/components/compositeFields/AutocompleteField.vue";
import TheCountrySelect from "@/components/basic/fields/TheCountrySelect.vue";

export default Vue.extend({
  name: "AddressDetails",
  data() {
    return {
      CorrespondenceMethod,
      correspondenceMethodArray: [
        {
          key: CorrespondenceMethod.EMAIL,
          value: this.$t(`steps.AddressDetails.correspondenceMethodOne`), // The object prefix has to be changed manually
        },
        {
          key: CorrespondenceMethod.POST_OFFICE,
          value: this.$t(`steps.AddressDetails.correspondenceMethodTwo`), // The object prefix has to be changed manually
        },
      ],
      isFilled: false,
      maxCorrespondenceHeight: 420,
      cityItemList: [] as FieldInterface[],
      streetItemList: [] as FieldInterface[],
      correspondenceCityItemList: [] as FieldInterface[],
      correspondenceStreetItemList: [] as FieldInterface[],
      addressRequest: null,
      cityStreetMap: {} as DataObject,
      correspondeneCityStreetMap: {} as DataObject,
      formData: {
        country: "",
        postalCode: "",
        searchAddress: "",
        city: "",
        street: "",
        buildingNumber: "",
        apartmentNumber: "",
        birthPlaceCity: "",
        birthPlaceCountry: "",
        correspondenceChoice: "",
        contactAddress: false,
        contactCountry: "",
        contactPostalCode: "",
        contactCity: "",
        contactStreet: "",
        contactBuildingNumber: "",
        contactApartmentNumber: "",
      } as StepResidenceDetails,
      TRANSLATION_KEY: "steps.AddressDetails",
      created: false,
    };
  },
  created() {
    this.created = true;
  },
  mounted() {
    this.$forceUpdate();
    if (this.$store.state.timeToFinish >= 6) {
      this.$store.commit(SET_PROGRESS, 6);
    }
  },
  methods: {
    populateDataForm() {
      const countryCodes = this.$store.state.formData.country ? this.$store.state.formData.country : ''
      const options = { countries: { codesList: countryCodes }, setCountryByIP: false };
      const fields = [{ element: "searchAddress", field: "searchAddress" }];
      //@ts-ignore
      const addressControl = new pca.Address(fields, options);
      addressControl.load();
      addressControl.listen("populate", (address:any) => {
        this.formData.postalCode = address.PostalCode
        this.formData.city = address.City
        this.formData.street = address.Street
        this.formData.buildingNumber = address.BuildingNumber
        this.formData.apartmentNumber = address.SubBuilding
      });
    },
    async getCityList(postalCode: string): Promise<any> {
      const promise = (this.addressRequest = this.$store.state.ajaxService
        .runAction(Action.GET_ADDRESS, {
          postalCode,
        })
        .catch((e: any) => console.error(e)));
      const data: AddressResponseInterface = await promise;

      const response = {
        cities: [] as any[],
        streets: new Map() as Map<string, string[]>,
      };

      const map = new Map<string, string[]>();

      Object.entries(data.postalCodeAddresses).forEach(([key, value]) => {
        response.cities.push(key);
        map.set(key, value as string[]);
      });

      response.streets = map;

      return response;
    },

    async requestCity(postalCode: string): Promise<void> {
      this.cityStreetMap = await this.getCityList(postalCode);

      this.cityItemList = this.getItemListFromStringArray(Array.from(this.cityStreetMap["cities"]));
    },
    getCityStreets() {
      if (this.formData.city != undefined) {
        let streetArray = this.cityStreetMap["streets"].get(this.formData.city);
        streetArray.sort();
        this.streetItemList = this.getItemListFromStringArray(Array.from(streetArray));
      }

      return this.streetItemList;
    },

    async requestCorrespondenceCity(postalCode: string): Promise<any> {
      this.correspondeneCityStreetMap = await this.getCityList(postalCode);

      this.correspondenceCityItemList = this.getItemListFromStringArray(
        Array.from(this.correspondeneCityStreetMap["cities"])
      );
    },

    getCorrespondenceStreets() {
      if (this.formData.contactCity != undefined) {
        let streetArray = this.correspondeneCityStreetMap["streets"].get(this.formData.contactCity);
        streetArray.sort();
        this.correspondenceStreetItemList = this.getItemListFromStringArray(Array.from(streetArray));
      }

      return this.correspondenceStreetItemList;
    },

    expandForm(): boolean {
      return (this.isFilled = !this.isFilled);
    },

    blockSendForm(evt: CustomEvent): void {
      evt.preventDefault();
    },

    keyupEvent(): void {
      window.addEventListener("keyup", (evt: KeyboardEvent) => {
        if (evt.key === "Enter") {
          if (!this.isFilled) {
            this.isFilled = true;
          }
        }
      });
    },

    getItemListFromStringArray(array: string[]): FieldInterface[] {
      const result: FieldInterface[] = [];

      array.forEach((elem, index) => {
        result.push({
          key: index,
          value: elem,
        });
      });

      return result;
    },
  },
  watch: {
    "formData.country"() {
      if (this.formData.country === "PL" && this.formData.postalCode.length === 6) {
        this.requestCity(this.formData.postalCode);
      }
      this.$store.state.country = this.formData.country;
    },
    "formData.postalCode"() {
      if (this.formData.country === "PL" && this.formData.postalCode.length === 6) {
        this.requestCity(this.formData.postalCode);
      }
    },
    "formData.contactAddress"() {
      this.formData.contactCountry = "";
      this.formData.contactPostalCode = "";
      this.formData.contactCity = "";
      this.formData.contactStreet = "";
      this.formData.contactBuildingNumber = "";
      this.formData.contactApartmentNumber = "";
    },
  },
  computed: {
    ...mapState({
      countries: (state: any): FieldInterface[] => state.config.countries,
      birthPlaceCountry: (state: any) => state.formData.birthPlaceCountry,
    }),
  },
  components: {
    CheckBox,
    Select,
    Field,
    FieldMask,
    SubmitButton,
    AutocompleteField,
    TheCountrySelect,
  },
});
